import { Component } from 'react';
import styles from '../../styles/step.scss';
import cx from 'classnames';

interface Props {
  title: string;
  subtitle: string;
  children: any;
}

class Steps extends Component<Props> {
  public render() {
    const { title, subtitle, children } = this.props;
    return (
      <div className={cx(styles['step-content'], 'inline-block mt10')}>
        <p className="text--xmd font--dark-grey font--bold mb10">{title}</p>
        {subtitle ? (
          <p
            dangerouslySetInnerHTML={{ __html: subtitle }}
            className="text--md font--grey"
          />
        ) : null}
        {/* {subtitle ? <ReactMarkdown className="text--md font--grey" source={subtitle} /> : null} */}
        {children || null}
      </div>
    );
  }
}

export default Steps;



// WEBPACK FOOTER //
// ./components/mandate/steps.tsx